import {
  ProposalCollaborationRealtimeNoticeZ,
  type ProposalCollaborationRealtimeNotice,
} from "work/proposals/negotiation/proposal-collaboration-contract";

export const PROPOSAL_COLLABORATION_REALTIME_EVENT_NAME = "proposal-negotiation-updated";

/**
 * Realtime carries only a version cursor so messages remain far below Ably's
 * payload limit. Consumers refetch the canonical authorized GET envelope; a
 * realtime update therefore cannot diverge from a full refresh.
 */
export function parseProposalCollaborationRealtimeNotice(payload: unknown): ProposalCollaborationRealtimeNotice {
  return ProposalCollaborationRealtimeNoticeZ.parse(payload);
}
